import fetchWrapper, { getConnection } from '@interhyp/util-request';

export const getUserToken = async () => {
  try {
    const res = await fetchWrapper(getConnection(), '/api/user-service/authorizations/me');
    if (res.status == 200) {
      return await res.json();
    }
    return null;
  } catch {
    return null;
  }
};

export const getSessionData = async () => {
  try {
    const res = await fetchWrapper(getConnection(), '/api/business/auth/employee/heartbeat', {
      method: 'PUT',
    });
    if (res.status === 200) {
      return await res.json();
    }
    return null;
  } catch {
    return null;
  }
};

/**
 * @deprecated
 */
export const authUser = async () => {
  try {
    const response = await fetchWrapper(getConnection(), '/api/business/auth/employee', {
      method: 'GET',
      mode: 'no-cors',
      cache: 'no-cache',
      redirect: 'follow',
      referrer: 'no-referrer',
    });
    if (response.status >= 200 && response.status < 300) {
      return true;
    }
    return null;
  } catch {
    return null;
  }
};

export const getCompanyConfiguration = async () => {
  try {
    const response = await fetchWrapper(getConnection(), 'api/business/v1/company-configuration', {
      method: 'GET',
    });
    if (response.status >= 200 && response.status < 300) {
      return await response.json();
    }
    return null;
  } catch {
    return null;
  }
};

export const getCaseAssignmentConfiguration = async () => {
  try {
    const response = await fetchWrapper(
      getConnection(),
      'api/business/v1/case-assignment-configuration',
      {
        method: 'GET',
      },
    );
    if (response.status >= 200 && response.status < 300) {
      return await response.json();
    }
    return null;
  } catch {
    return null;
  }
};

export const getFeatureConfiguration = async () => {
  try {
    const response = await fetchWrapper(getConnection(), 'api/business/v1/feature-configuration', {
      method: 'GET',
    });
    if (response.status >= 200 && response.status < 300) {
      return await response.json();
    }
    return null;
  } catch {
    return null;
  }
};
